import { render, staticRenderFns } from "./PaginationBar.vue?vue&type=template&id=4a523835&scoped=true"
import script from "./PaginationBar.vue?vue&type=script&lang=js"
export * from "./PaginationBar.vue?vue&type=script&lang=js"
import style0 from "./PaginationBar.vue?vue&type=style&index=0&id=4a523835&prod&lang=scss&scoped=true"
import style1 from "./PaginationBar.vue?vue&type=style&index=1&id=4a523835&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a523835",
  null
  
)

export default component.exports